import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { Badge } from '@octopus-do/octopus-storybook'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './styles.module.css'

interface Props {
  isNew: boolean
  exportable: boolean
}

export const ExportBadge: React.FC<Props> = ({ isNew, exportable }) => {
  const dispatch = useDispatch()

  const handleClickBadge = () => {
    sendGtmEvent(GtmTriggerName.UPGRADE_EXPORT)

    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: {
          slideType: 'export',
        },
      })
    )
  }

  if (exportable && !isNew) {
    return null
  }

  const type = exportable && isNew ? 'new' : 'pro'

  return (
    <div className={css.badge} onClick={handleClickBadge}>
      <Badge type={type} size="large" />
    </div>
  )
}
